import { RoundsSegmentGroupBase } from "../RoundsSegmentGroup";
import { TournamentSegmentBase } from "../TournamentSegment";
import { AltSeasonPointsRules, SeasonPointsRules } from "./SeasonPointRules";

export type SeasonSegment = TournamentSegmentBase<"Season", Season> & {
  altPoints: AltSeasonPointsRules[] | undefined;
  points: SeasonPointsRules | undefined;
  pointsOverrides: SeasonPointsOverrides | undefined;
};

export type Season = RoundsSegmentGroupBase & {};

export type SeasonPointOverride = {
  bonus: number | undefined;
  result: number | "Qual" | undefined;
};

export type SeasonPointsOverrides = {
  [matchId: string]:
    | {
        [rosterId: string]: "Qual" | number | SeasonPointOverride | undefined;
      }
    | undefined;
};

export const getPointsRules = (
  matchId: string,
  points: SeasonPointsRules | undefined,
  altPoints: AltSeasonPointsRules[] | undefined
) => {
  const matchAltPoints = altPoints?.find((a) =>
    a.matchIds.includes(matchId)
  )?.points;

  return matchAltPoints ?? points;
};

export const getSeasonRosterPointsOverride = (
  overrides: SeasonPointsOverrides,
  matchId: string,
  rosterId: string
): SeasonPointOverride | undefined => {
  const rosterOverride = overrides?.[matchId]?.[rosterId];
  if (rosterOverride === undefined) {
    return undefined;
  }

  if (
    typeof rosterOverride === "string" ||
    typeof rosterOverride === "number"
  ) {
    return {
      result: rosterOverride,
      bonus: undefined,
    };
  }
  return rosterOverride;
};
